const colors = require('tailwindcss/colors')

function hexToRgb(hex) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b
  })

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        red: parseInt(result[1], 16),
        green: parseInt(result[2], 16),
        blue: parseInt(result[3], 16),
      }
    : null
}

function makeShadow(name, rgb) {
  const obj = {}

  const nameWithDash = name ? `${name}-` : ''

  obj[`${nameWithDash}xs`] = `0px 0px 2px 0px rgba(${rgb}, 0.12)`
  obj[
    `${nameWithDash}sm`
  ] = `0px 1px 4px 0px rgba(${rgb}, 0.06), 0px 0px 2px 0px rgba(${rgb}, 0.12)`
  obj[
    `${nameWithDash}dddddd`
  ] = `0px 4px 8px 0px rgba(${rgb}, 0.08),0px 1px 4px 0px rgba(${rgb}, 0.12)`
  obj[
    `${nameWithDash}md`
  ] = `0px 6px 12px 0px rgba(${rgb}, 0.08),0px 4px 8px 0px rgba(${rgb}, 0.1),0px 1px 4px 0px rgba(${rgb}, 0.12)`
  obj[
    `${nameWithDash}lg`
  ] = `0px 12px 20px 0px rgba(${rgb}, 0.06),0px 6px 12px 0px rgba(${rgb}, 0.08),0px 2px 4px 0px rgba(${rgb}, 0.06)`
  obj[
    `${nameWithDash}xl`
  ] = `0px 14px 24px 0px rgba(${rgb}, 0.08),0px 6px 12px 0px rgba(${rgb}, 0.12),0px 3px 6px 0px rgba(${rgb}, 0.08)`
  obj[
    `${nameWithDash}2xl`
  ] = `0px 16px 28px -1px rgba(${rgb}, 0.1),0px 8px 16px 0px rgba(${rgb}, 0.16),0px 4px 8px 0px rgba(${rgb}, 0.1)`
  obj[
    `${nameWithDash}3xl`
  ] = `0px 20px 40px -1px rgba(${rgb}, 0.12),0px 12px 18px 0px rgba(${rgb}, 0.2),0px 6px 10px 0px rgba(${rgb}, 0.12)`
  obj[
    `${nameWithDash}4xl`
  ] = `0px 20px 38px -2px rgba(${rgb}, 0.06),0px 16px 24px -1px rgba(${rgb}, 0.12),0px 10px 20px 0px rgba(${rgb}, 0.12),0px 5px 10px 0px rgba(${rgb}, 0.06)`
  obj[
    `${nameWithDash}5xl`
  ] = `0px 32px 64px -2px rgba(${rgb}, 0.08),0px 24px 32px -1px rgba(${rgb}, 0.16),0px 10px 20px 0px rgba(${rgb}, 0.16),0px 5px 10px 0px rgba(${rgb}, 0.08)`
  obj[
    `${nameWithDash}6xl`
  ] = `0px 40px 72px -5px rgba(${rgb}, 0.24),0px 32px 64px -4px rgba(${rgb}, 0.14),0px 16px 32px -3px rgba(${rgb}, 0.12),0px 10px 20px -2px rgba(${rgb}, 0.1),0px 5px 10px -1px rgba(${rgb}, 0.06)`
  obj[
    `${nameWithDash}7xl`
  ] = `0px 56px 84px -5px rgba(${rgb}, 0.32),0px 32px 64px -4px rgba(${rgb}, 0.14),0px 16px 32px -3px rgba(${rgb}, 0.12),0px 10px 20px -2px rgba(${rgb}, 0.1),0px 5px 10px -1px rgba(${rgb}, 0.06)`

  obj[`${nameWithDash}inner`] = `inset 0 2px 4px 0 rgba(${rgb}, 0.06)`

  return obj
}

function buildShadowPalette(theme) {
  // default tailwindcss black shadows
  const defaultPalette = {
    ...makeShadow('', '0, 0, 0'),
    outline: '0 0 0 3px rgba(66, 153, 225, 0.5)',
    none: 'none',
  }

  const coloredShadowPalette = Object.values(
    Object.entries(theme('colors')).reduce((acc, curr) => {
      const [k, v] = curr
      if (
        typeof v === 'string' &&
        v !== 'transparent' &&
        v !== 'currentColor'
      ) {
        const { red, green, blue } = hexToRgb(v)
        acc[k] = makeShadow(k, `${red}, ${green}, ${blue}`)
      }
      if (typeof v === 'object') {
        Object.entries(v).forEach(([_k, _v]) => {
          const { red, green, blue } = hexToRgb(_v)
          acc[`${k}-${_k}`] = makeShadow(
            `${k}-${_k}`,
            `${red}, ${green}, ${blue}`
          )
        })
      }
      return acc
    }, {})
  )

  return coloredShadowPalette.reduce(
    (acc, cur) => ({ ...acc, ...cur }),
    defaultPalette
  )
}

module.exports = {
  mode: 'jit',
  purge: ['./src/**/*.{js,jsx,ts,tsx}'],
  darkMode: false, // or 'media' or 'class'
  theme: {
    extend: {
      colors: {
        ...colors,
        primary: colors.blue,
        gray: colors.blueGray,
      },
      transitionDuration: {
        default: '350ms',
      },
      container: {
        center: true,
        padding: {
          DEFAULT: '2rem',
          lg: '4rem',
          xl: '5rem',
        },
      },
      fontFamily: {
        body: ['Ubuntu', 'ui-sans-serif'],
        serif: ['Crimson Text', 'ui-serif'],
      },

      boxShadow: (theme) => {
        return {
          ...buildShadowPalette(theme),
        }
      },
    },
  },
  variants: {
    extend: {},
  },
  plugins: [require('@tailwindcss/typography')],
}
